import { Map, Record } from 'immutable';
import { handleActions } from 'redux-actions';
import * as t from './actionTypes';

const ReducerRecord = new Record({
  account: Map({
    user: null
  }),
  app: Map({
    isAuthenticated: false,
    isAuthenticating: true
  }),
  ui: Map({
    isLoading: false,
    isError: false,
    errorMessage: null
  })
});
const initialState = new ReducerRecord();

export default handleActions(
  {
    [t.NETWORK_START]: state =>
      state.set(
        'ui',
        state.get('ui').merge(
          Map({
            isLoading: true,
            isError: false,
            errorMessage: null
          })
        )
      ),

    [t.NETWORK_RESET]: state =>
      state.set(
        'ui',
        state.get('ui').merge(
          Map({
            isLoading: false,
            isError: false,
            errorMessage: null
          })
        )
      ),

    [t.NETWORK_ERROR]: (state, action) =>
      state.set(
        'ui',
        state.get('ui').merge(
          Map({
            isLoading: false,
            isError: true,
            errorMessage: action.payload
          })
        )
      ),

    [t.USER_LOGIN]: (state, action) =>
      state
        .setIn(['account', 'user'], action.payload)
        .setIn(['app', 'isAuthenticated'], true),

    [t.USER_LOGOUT]: (state, action) =>
      state
        .setIn(['account', 'user'], null)
        .setIn(['app', 'isAuthenticated'], false),

    [t.IS_AUTHENTICATED_SET]: (state, action) =>
      state.setIn(['app', 'isAuthenticated'], action.payload),

    [t.IS_AUTHENTICATING_SET]: (state, action) =>
      state.setIn(['app', 'isAuthenticating'], action.payload)
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/modules/auth/reducer.js